export const widgetIds = {
    courses: 1,
    meetings: 2,
    activity: 3,
    studentRetention: 4,
    studentPersistence: 5,
    courseCompletion: 6,
    caseloadTermPersistenceRiskSummary: 7,
    caseloadCourseCompletionRiskSummary: 8,
    academicPlanSummary: 9,
    recentUnreadMessages: 10,
    tasks: 11,
    caseloadTasks: 12,
    caseloadKeyEngagements: 13,
    teamKeyEngagements: 14,
    keyEngagementScoresByTeam: 15,
    report: 16,
    alerts: 17,
};
